<template>
    <div class="search">
        <!-- 1. 搜索框 -->
        <div class="search-layout-title-bar dsp-flex">
            <div class="title-side title-left" @click="clickBack">
                <i class="iconfont icon-guanbi"></i>
            </div>
            <div class="title-middle">
                <search-input 
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
            <div class="title-side title-green" @click="clickSearch">搜索</div>
        </div>

        <div v-if="searchResultList.length == 0" class="search-layout-content">
            <!-- 2. 选择栏 -->
            <search-select-box></search-select-box>

            <!-- 3. 高级搜索 -->
            <div class="search-title-note">高级搜索</div>
            <div class="search-high-list dsp-flex">
                <div class="search-high-item" @click="clickAdvanced('ganzhi')">
                    <span class="search-high-icon search-high-icon-gz"></span>
                    <p>干支搜索</p>
                </div>
                <div class="search-high-item" @click="clickAdvanced('wuxing')">
                    <span class="search-high-icon search-high-icon-wx"></span>
                    <p>五行搜索</p>
                </div>
                <div class="search-high-item" @click="clickLabel">
                    <span class="search-high-icon search-high-icon-label"></span>
                    <p>标签搜索</p>
                </div>
            </div>
        </div>

        <!-- 4. 搜索结果显示 -->
        <div v-if="searchResultList.length > 0" class="search-result-list">
            <virtual-list id="SearchList" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="searchResultList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'com-record-item-w90'" />
        </div>

        <!-- 5. 删除提示弹框 -->
        <delete-record-item-pop></delete-record-item-pop>

        <!-- 6. 新建对比弹框 -->
        <van-popup v-bind:value="showContrastCreatePanel" class="layout-contrast-create-pop-box" @click-overlay="clickContrastCreateOverlay">
            <vant-contrast-create-pop></vant-contrast-create-pop>
        </van-popup>

        <router-view></router-view>
    </div>
</template>

<script>
import SearchInput from '../components/SearchInput.vue'
import SearchSelectBox from "../layouts/search/SearchSelectBox.vue";
import SearchResultItem from '../components/search/SearchResultItem.vue'
import DeleteRecordItemPop from '../layouts/popup/DeleteRecordItemPop.vue'
import VantContrastCreatePop from '../layouts/vant/VantContrastCreatePop.vue'
import { DOM, SEARCH_DOM } from '../modules/dom';
import { MIX } from '../modules/utils';
export default {
    name: 'Search',
    components: { SearchInput, SearchSelectBox, DeleteRecordItemPop, VantContrastCreatePop },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchSelectedData() {
            return this.$store.state.search.searchSelectedData;
        },
        searchResultList() {
            return this.$store.state.search.searchResultList;
        },
        showContrastCreatePanel() {
            return this.$store.state.contrast.showContrastCreatePanel;
        },
    },
    data() {
        return {
            searchInputId: 'searchInput',
            itemComponent: SearchResultItem
        }
    },
    mounted: function() {
        setTimeout(() => {
            SEARCH_DOM.updateSearchPageStyle();
            MIX.trackPageViewed('SearchMainPage');
        }, 100);
    },
    created: function() {
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
    },
    methods: {
        clickBack() {
            this.$store.dispatch('search/resetData');
            this.$store.state.search.searchSelectedData = Object.assign({situation: 0, sex: -1, age: 0});
            // 处理返回页面跳转
            let fromPage = this.$router.history.current.params.from;
            if(!fromPage) fromPage = 'record';
            if(fromPage == 'record') {
                this.$router.replace('/record');
                setTimeout(() => {
                    this.$store.dispatch('record/updateRecordFilterList');
                }, 20);
            }else if(fromPage == 'collate') {
                this.$router.replace('/collate');
            }else {
                this.$router.replace('/record');
            }
        },
        inputSearch(word) {
            this.$store.state.search.searchData.searchText = word;
            if(word != ''){
                this.$store.dispatch('search/confirmSearchInput', word);
            }else{
                this.$store.state.search.searchResultList = [];
            }
            setTimeout(() => {
                SEARCH_DOM.updateSearchPageStyle();
            }, 20);
        },
        clickSearch() {
            var word = this.$store.state.search.searchData.searchText;
            if(word == ''){
                if(this.searchSelectedData.situation == 0 && this.searchSelectedData.sex == -1) {
                    // 如果没有搜索条件
                    this.$toast('请选择搜索条件')
                }else{
                    this.$store.dispatch('search/confirmSearchInput', '');
                    this.$store.state.search.searchResultFromPage = 'search';
                    this.$toast({
                        message: '找到'+this.searchResultList.length+'条符合条件的命盘记录',
                        className: 'van-toast--width-50',
                    });
                    this.$router.replace('/search/result');
                    DOM.setHiddenByClassName('search-layout-content');
                }
            }
        },
        clickAdvanced(type) {
            let curUrl = this.$router.history.current.fullPath;
            this.$store.dispatch('search/resetData');
            this.$store.state.search.advancedType = type;
            this.$router.replace(curUrl+'/advanced');
        },
        clickLabel() {
            let curUrl = this.$router.history.current.fullPath;
            this.$store.dispatch('label/resetData');
            this.$store.dispatch('search/resetData');
            this.$router.replace(curUrl+'/label');
        },
        clickContrastCreateOverlay() {
            this.$store.state.contrast.showContrastCreatePanel = false;
        }
    }
}
</script>